import { makeStyles } from '@mui/styles';

export const useStyles = makeStyles((theme) => ({
  icon: {
    height: '80px',
    width: '80px',
    [theme.breakpoints.down('sm')]: {
      height: '40px',
      width: '40px',
    },
    background: 'white',
    marginBottom: '5px',
  },
  buttonText: {
    marginLeft: '11px',
  },
  padding: {
    padding: '20px',
  },
  inputError: {
    backgroundColor: '#FFF1F1',
    color: 'red',
  },
}));
